import { Component } from '@angular/core';

@Component({
  selector: 'app-add-quickbooks',
  templateUrl: './add-quickbooks.component.html',
  styleUrls: ['./add-quickbooks.component.css']
})
export class AddQuickbooksComponent {

}
